/* import __COLOCATED_TEMPLATE__ from './user-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const UserRow = dt7948.c(class UserRow extends SelectKitRowComponent {}, [classNames("user-row")]);
export default UserRow;